import styled from '@emotion/styled';
import { theme } from '../../themes';
import { themeVariables } from '../../themeVariables';


export type TextFieldComponentStyledPropsType = {
  fullWidth?: boolean;
};

const TextFieldComponentStyled = styled.div<TextFieldComponentStyledPropsType>`
  width: ${props => (props.fullWidth ? '100%' : 'initial')};
  label {
    font-family: ${() => theme.typography.fontFamily};
  }

  .MuiOutlinedInput-root {
    padding: 15px 20px;
    border: 2px solid ${() => themeVariables.colors.primary};
    background: #fff;
    box-sizing: border-box;
    cursor: text;
    border-radius: 0 !important;
  }

  .MuiOutlinedInput-input {
    flex: 1;
    box-shadow: none;
    border: none;
    margin: 0;
    padding: 0;
    background-color: transparent;
    font-size: 14px;
    font-weight: ${() => themeVariables.fontWeights.regular};
    line-height: 17px;
    border-radius: 0 !important;
  }

  .MuiInputLabel-outlined.Mui-focused {
    color: ${() => themeVariables.colors.dark};
  }

  .MuiInputLabel-outlined {
    position: relative;
    margin-left: -13px;
    text-transform: uppercase;
    color: ${() => themeVariables.colors.dark};
    font-weight: ${() => themeVariables.fontWeights.bold};
    font-size: 1rem;
    line-height: 15px;
  }

  .MuiOutlinedInput-notchedOutline{
    border: 0;
  }


`;

export default TextFieldComponentStyled;
